
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import DlgEventNew from '@/modules/admin/events/_components/DlgEventNew.vue';
  import Card from '@/components/material/Card.vue';
  import DlgEventDelete from '@/modules/admin/events/_components/DlgEventDelete.vue';

  @Component({
    components: {DlgEventDelete, Card, DlgEventNew},
  })
  export default class VEventList extends Vue {
    @Action('admin/events/read') private readAll!: any;

    @Getter('admin/events/all') private events!: any;

    private pagination: any = {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'date',
    };

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: 'Deadline',
        align: 'left',
        sortable: true,
        value: 'deadline',
      },
      {
        text: 'Veranstaltungsdatum',
        align: 'left',
        sortable: true,
        value: 'date',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.readAll();
      this.loading = false;
    }
  }
